webpackJsonp([114276838955818,60335399758886],{

/***/ 104:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 196:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(202);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(104);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 299:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 200:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(35);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	__webpack_require__(299);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Footer = function Footer() {
	  return _react2.default.createElement(
	    'footer',
	    { id: 'app-footer' },
	    _react2.default.createElement(
	      'section',
	      { className: 'sitemap' },
	      _react2.default.createElement(_gatsbyLink2.default, { to: '/', className: 'nav-home' }),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h5',
	          null,
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/' },
	            'Johnny Metrics'
	          )
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/#pricing' },
	          'Pricing'
	        ),
	        _react2.default.createElement(
	          'a',
	          { href: ("http://app.johnnymetrics.com") + '/signin' },
	          'Log in'
	        ),
	        _react2.default.createElement(
	          'a',
	          { href: ("http://app.johnnymetrics.com") + '/signup' },
	          'Sign up for a free trial'
	        ),
	        _react2.default.createElement(
	          'a',
	          { href: ("https://www.johnnymetrics.com/demo") },
	          'Demo'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h5',
	          null,
	          'Keep in touch'
	        ),
	        _react2.default.createElement(
	          'a',
	          { href: 'mailto:info@johnnymetrics.com' },
	          'Email us'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h5',
	          null,
	          'Fine print'
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/privacy' },
	          'Privacy'
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/terms' },
	          'Terms of service'
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/security' },
	          'Security overview'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'section',
	      { className: 'copyright' },
	      'Brought to you by your friends at Johnny Metrics | \xA9 2017 - 2018;  BREAKFAST 61, Accounts Department 6, Castlewood House, 77-91 New Oxford Street, London, WC1A 1DG'
	    )
	  );
	};
	
	exports.default = Footer;
	module.exports = exports['default'];

/***/ }),

/***/ 300:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 201:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(35);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Nav = __webpack_require__(73);
	
	var _Nav2 = _interopRequireDefault(_Nav);
	
	__webpack_require__(300);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Header = function Header() {
	  return _react2.default.createElement(
	    'header',
	    { id: 'app-header' },
	    _react2.default.createElement(
	      'section',
	      null,
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/', className: 'nav-home' },
	        'Johnny Metrics'
	      ),
	      _react2.default.createElement(_Nav2.default, null)
	    )
	  );
	};
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),

/***/ 73:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(35);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Nav = function Nav() {
	  return _react2.default.createElement(
	    'nav',
	    null,
	    _react2.default.createElement(
	      'a',
	      { href: '' + ("https://www.johnnymetrics.com/demo") },
	      'Demo'
	    ),
	    _react2.default.createElement(
	      _gatsbyLink2.default,
	      { to: '/#pricing' },
	      'Pricing'
	    ),
	    _react2.default.createElement(
	      'a',
	      { href: ("http://app.johnnymetrics.com") + '/signup' },
	      'Sign up'
	    ),
	    _react2.default.createElement(
	      'a',
	      { href: '' + ("http://app.johnnymetrics.com") },
	      'App \u2192'
	    )
	  );
	};
	
	exports.default = Nav;
	module.exports = exports['default'];

/***/ }),

/***/ 301:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 302:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 303:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 202:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(24);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	__webpack_require__(304);
	
	var _Header = __webpack_require__(201);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(200);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	__webpack_require__(303);
	
	__webpack_require__(302);
	
	__webpack_require__(301);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TemplateWrapper = function TemplateWrapper(_ref) {
	  var children = _ref.children;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_reactHelmet2.default, {
	      title: 'Johnny Metrics :: Crypto portfolio tracker and reporting'
	    }),
	    _react2.default.createElement(_Header2.default, null),
	    _react2.default.createElement(
	      'div',
	      null,
	      children()
	    ),
	    _react2.default.createElement(_Footer2.default, null)
	  );
	};
	
	TemplateWrapper.propTypes = {
	  children: _propTypes2.default.func
	};
	
	exports.default = TemplateWrapper;
	module.exports = exports['default'];

/***/ }),

/***/ 304:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-240b3cbf2e59830540ab.js